import React, { useCallback } from "react";
import classNames from "classnames";
import { isBefore, isSameDay } from "date-fns";
import { DatePickerInput } from "../../forms/dates/DatePickerInput/DatePickerInput";
import { useLockDate } from "../../../api/lock.api";
import { EditableTableCell, EditableTableCellProps } from "./EditableTableCell";
import styles from "./EditableTable.module.scss";

interface EditableTableCellSearchProps
    extends Omit<EditableTableCellProps, "children"> {
    onChange: undefined | ((value: string | number | null) => void);
    value: string;
    entityId?: number;
}

export const EditableTableCellDate = React.memo(
    ({
        id,
        isFirstRow,
        onChange,
        value,
        error,
        selectionState,
        className,
        entityId,
    }: EditableTableCellSearchProps) => {
        const cellRef = React.useRef<HTMLDivElement>(null);
        const lockDate = useLockDate(entityId);

        const tileDisabled = useCallback(
            ({ date: chosenDate }: { date: Date }) => {
                if (!lockDate) {
                    return false;
                }
                return (
                    isBefore(chosenDate, lockDate) ||
                    isSameDay(chosenDate, lockDate)
                );
            },
            [lockDate],
        );

        return (
            <EditableTableCell
                id={id}
                isFirstRow={isFirstRow}
                error={error}
                selectionState={selectionState}
                className={classNames(styles.dateEditableCell, className)}
                ref={cellRef}
            >
                <DatePickerInput
                    value={value}
                    name="date"
                    tileDisabled={tileDisabled}
                    popoverContainer={cellRef.current ?? undefined}
                    onChange={(newValue) => {
                        if (newValue) {
                            onChange?.(newValue);
                        }
                    }}
                    inputSize="sm"
                />
            </EditableTableCell>
        );
    },
);
